export enum FoodProductStatus {
    Enabled = 1,
    Disabled = 2
}
